import { accountLoad } from '../../../api/g/account'
import { logoutSend } from '../../../api/g/passport'
import { LOGIN_CROP_XS } from '../../../const'
import { KAccount } from '../../../models/k-user'

async function load({ commit }, args) {
  // TODO: 判断未登录状态下，清空缓存数据
  let info = await accountLoad(args)
  info =
    info && info.uid > 0
      ? info
      : KAccount({
          uid: 0
        })
  commit('update', {
    info
  })
  return info
}
async function read({ state, dispatch }) {
  let { info } = state
  if (!!info && info.uid > 0) {
    return info
  }
  info = await dispatch('load')
  return info
}

async function loadUid({ dispatch }) {
  const info = await dispatch('load', {})
  // console.log(info)
  return info && info.uid > 0 ? +info.uid : 0
}

async function readUid({ getters, dispatch }) {
  let { uid } = getters
  if (!uid) {
    uid = await dispatch('loadUid')
  }
  return uid > 0 ? +uid : 0
}

async function logout({ dispatch }) {
  const R = await logoutSend({
    corp: LOGIN_CROP_XS
  })
  await dispatch('load', {})
  return R
}


export default {
  load,
  loadUid,
  read,
  readUid,
  logout,
}
